import React, { useCallback, useEffect, useState } from "react";
import "../assets/styles/landingpage.css";
import { Avatar, Button, Card, Col, Divider, Layout, List, Menu, Row, Skeleton, Space, Typography } from "antd";
import logo from '../assets/images/logo.png'
import { Link, useNavigate } from "react-router-dom";

import Get from "../services/Get";
import { FacebookOutlined, InstagramOutlined, LinkedinOutlined, TwitterOutlined } from "@ant-design/icons";
import LandingFooter from "../components/layout/Footer";
import LandingHeader from "../components/layout/Header";
import InfiniteScroll from 'react-infinite-scroll-component';
import debounce from "lodash.debounce";

const LandingPage = () => {
    const navigate = useNavigate();
    const [listing, setListing] = useState([]);
    const [showMore, setShowMore] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [url, setUrl] = useState();

    const getListingCategory = () => {
        Get.ListingCategory("").then((res) => {
            setListing(res);
        })
    }

    const handleClick = (slug) => {
        navigate(`/list-services?category=${slug}`);
    }

    const getListing = useCallback(
        debounce((query) => {
            if (!query.trim()) {
                setSearchData([]); // Clear results if input is empty
                return;
            }

            setLoading(true);

            Get.SearchListing(query)
                .then((res) => {
                    console.log("API Response: ", res);
                    setSearchData(res.data.data);
                    setUrl(res.url);
                })
                .catch((err) => console.error("Error fetching data:", err))
                .finally(() => setLoading(false));
        }, 500), // Wait 500ms before making the API request
        []
    );

    useEffect(() => {
        getListing(searchText);
    }, [searchText, getListing]);

    useEffect(() => {
        getListingCategory();
    }, []);

    return (
        <div>
            <Layout className="landing-page">
                <LandingHeader />

                {/* Main Content with Search Engine */}
                <div className="main-content image-container">
                    <div className="img_logo">
                        <img src={logo} alt="Logo" />
                        <div className="search-container">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Search for services..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                            <button className="search-button" onClick={() => navigate(`/list-services?search=${searchText}`)}>
                                Search
                            </button>
                        </div>

                        {/* Show results only if there is data */}
                        {searchData.length > 0 && (
                            <div
                                id="scrollableDiv"
                                style={{
                                    maxHeight: 200,
                                    overflow: "auto",
                                    padding: "0 16px",
                                    border: "1px solid rgba(140, 140, 140, 0.35)",
                                    backgroundColor: "#fff",
                                }}
                            >
                                <InfiniteScroll
                                    dataLength={searchData.length}
                                    hasMore={false} // Set to true if you implement "loadMoreData"
                                    loader={loading && <Skeleton avatar paragraph={{ rows: 1 }} active />}
                                    scrollableTarget="scrollableDiv"
                                >
                                    <List
                                        dataSource={searchData}
                                        renderItem={(item) => (
                                            <List.Item key={item.id}>
                                                <List.Item.Meta
                                                    avatar={<Avatar src={`${url}/${item.logo}`} />}
                                                    title={<Link to={`/business-details/${item.slug}`}>{item.business_name}</Link>}
                                                    description={item.city}
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </InfiniteScroll>
                            </div>
                        )}
                    </div>
                </div>

                <nav className="bottom-navbar">
                    {showMore ? (
                        <Row justify={'space-around'} style={{ padding: '0 50px' }}>
                            <Row
                                gutter={[18, 18]}
                                style={{
                                    
                                    textAlign: "center",
                                    justifyContent: 'space-around',
                                    display:'flex',
                                }}
                               
                            >
                                {listing.data?.map((service, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            textAlign: "center",
                                            margin: "0 25px",
                                            cursor: "pointer",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                        }}
                                        onClick={() => handleClick(service.slug)}
                                    >
                                        <div className="bottom-bar-icon-wrapper">
                                            <img
                                                src={listing.url + '/' + service.icon}
                                                alt={service.name}
                                                className="service-icon"
                                            />
                                        </div>
                                        <Typography.Text style={{ marginTop: 10, width: 117, fontSize: 'small' }}>
                                            {service.name}
                                        </Typography.Text>
                                    </div>
                                ))}
                                <div
                                    style={{
                                        textAlign: "center",
                                        margin: "0 25px",
                                        cursor: "pointer",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}
                                    onClick={() => setShowMore(false)}
                                >
                                    <div className="bottom-bar-icon-wrapper" style={{ alignItems: 'center' }}>
                                        <Typography.Title style={{ marginTop: 10, width: 117 }}>
                                            ...
                                        </Typography.Title>
                                    </div>
                                    <Typography.Text style={{ marginTop: 10, maxWidth: 117, fontSize: 'small' }}>
                                        Show Less
                                    </Typography.Text>
                                </div>
                            </Row>
                        </Row>
                    ) : (
                        <Row justify={'center'} style={{ padding: '0 40px' }}>
                            <Row
                                gutter={[16, 16]}
                                style={{
                                    textAlign: "center",
                                    justifyContent: 'space-around',
                                    display:'flex',
                                }}
                               
                            >
                                {listing.data?.slice(0, 11).map((service, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            textAlign: "center",
                                            margin: "0 25px",
                                            cursor: "pointer",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                        }}
                                        onClick={() => handleClick(service.slug)}
                                    >
                                        <div className="bottom-bar-icon-wrapper">
                                            <img
                                                src={listing.url + '/' + service.icon}
                                                alt={service.name}
                                                className="service-icon"
                                            />
                                        </div>
                                        <Typography.Text style={{ marginTop: 10, maxWidth: 100, fontSize: 'small' }} ellipsis={{ rows: 4, expandable: false }}>
                                            {service.name}
                                        </Typography.Text>
                                    </div>
                                ))}
                                <div
                                    style={{
                                        textAlign: "center",
                                        margin: "0 25px",
                                        cursor: "pointer",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}
                                    onClick={() => setShowMore(true)}
                                >
                                    <div className="bottom-bar-icon-wrapper" style={{ alignItems: 'center' }}>
                                        <Typography.Title style={{ marginTop: 10, width: 100 }}>
                                            ...
                                        </Typography.Title>
                                    </div>
                                    <Typography.Text style={{ marginTop: 10, maxWidth: 100, fontSize: 'small' }}>
                                        Share More
                                    </Typography.Text>
                                </div>
                            </Row>
                        </Row>
                    )}
                </nav >
            </Layout>
            <LandingFooter />
        </div>
    );
};

export default LandingPage;
